import LegalDocumentPage from '../components/legal/LegalDocumentPage.jsx'

const sections = [
  {
    title: 'Éditeur du site',
    paragraphs: [
      'Le présent site est édité par USTS, société responsable de la publication et de l’exploitation de la plateforme accessible à l’adresse usts.ai.',
      'Les informations juridiques détaillées de l’éditeur doivent être complétées avec les coordonnées exactes de votre structure.',
    ],
  },
  {
    title: 'Contact',
    paragraphs: [
      'Pour toute demande relative au site ou à son contenu, vous pouvez contacter l’équipe via l’adresse ci-dessous.',
    ],
    note: 'Remplacez cette adresse par le contact officiel de votre société si nécessaire.',
  },
  {
    title: 'Hébergeur',
    paragraphs: [
      'Le site est hébergé par un prestataire technique dont l’identité complète et les coordonnées doivent être renseignées conformément aux obligations légales applicables.',
      'Les informations d’hébergement peuvent être mises à jour en fonction de votre infrastructure de production.',
    ],
  },
  {
    title: 'Propriété intellectuelle',
    paragraphs: [
      'L’ensemble des contenus, marques, interfaces, textes, visuels et éléments techniques présents sur le site sont protégés par les règles de propriété intellectuelle.',
      'Toute reproduction ou exploitation non autorisée est interdite.',
    ],
  },
  {
    title: 'Responsabilité',
    paragraphs: [
      'L’éditeur met tout en œuvre pour assurer la fiabilité des informations présentes sur le site, mais ne peut garantir l’absence totale d’erreurs ou d’interruptions.',
      'L’utilisateur reste responsable de l’usage qu’il fait des informations disponibles sur le site.',
    ],
  },
]

export default function LegalNotice() {
  return (
    <LegalDocumentPage
      title="Mentions légales"
      subtitle="Informations d’identification et d’exploitation du site"
      lastUpdated="02 avril 2026"
      intro="Cette page regroupe les mentions légales du site USTS. Elle est publiée publiquement et peut être utilisée comme référence pour les obligations de transparence."
      sections={sections}
      contactEmail="contact@usts.ai"
      contactLabel="Contact éditeur"
      contactDescription="Pour toute demande concernant le site, ses contenus ou son exploitation, utilisez l’adresse ci-dessous."
    />
  )
}
